import { Injectable } from "@angular/core";
import {HttpClient, HttpContext, HttpHeaders, HttpParams} from "@angular/common/http";
import {environment} from '../../environments/environment';
import { SKIP_AUTH } from '../interceptors/http.interceptor';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: "root"
})
export class CommunicationService {

  constructor(private httpClient: HttpClient) { }

  get apiUrl(): string {
    return environment.baseUrl;
  }

  public httpGet<T>(path: string, options?: { headers?: HttpHeaders; params?: Record<string, any>; skipAuth?: boolean }) {
    const fullUrl = this.apiUrl + path;
    const filteredParams = this.addQueryParams(options?.params);
    const context = new HttpContext();
    if (options?.skipAuth) {
      context.set(SKIP_AUTH, true);
    }
    const httpOptions = {
      headers: options?.headers,
      params: new HttpParams({ fromObject: filteredParams }),
      context
    };

    return this.httpClient.get<T>(fullUrl, httpOptions);
  }

  public httpPut<T>(path: string, body: object, options?: HttpHeaders){
    let headers: HttpHeaders | undefined = options;
    return this.httpClient.put<T>(this.apiUrl + path, body, {headers});
  }

  public httpPost<T>(path: string, body: object, options?: { headers?: HttpHeaders; skipAuth?: boolean }){
    let headers: HttpHeaders | undefined = options?.headers;
    const context = new HttpContext();
    if (options?.skipAuth) {
      context.set(SKIP_AUTH, true);
    }
    return this.httpClient.post<T>(this.apiUrl + path, body, {headers, context});
  }

  public httpPostBlob(path: string, body: object, options?: HttpHeaders) {
    return this.httpClient.post(this.apiUrl + path, body, {
      headers: options,
      responseType: 'blob',
      observe: 'response'
    });
  }

  public httpDelete<T>(path: string, options?: HttpHeaders){
    let headers: HttpHeaders | undefined = options;
    return this.httpClient.delete<T>(this.apiUrl + path, {headers});
  }

  private addQueryParams(params: Record<string, any> | undefined){
    const filteredParams: Record<string, any> = {};
    if (params) {
      for (const [key, value] of Object.entries(params)) {
        if (value !== undefined && value !== null && value !== '') {
          filteredParams[key] = value;
        }
      }
    }
    return filteredParams;
  }

  public postRequest<TResponse>(url: string, body: object, options?: { headers?: HttpHeaders; skipAuth?: boolean }): Observable<TResponse>{
    let headers: HttpHeaders | undefined = options?.headers;
    const context = new HttpContext();
    if (options?.skipAuth) {
      context.set(SKIP_AUTH, true);
    }
    return this.httpClient.post<TResponse>(url, body, {headers, context});
  }
}
